export default "__VITE_ASSET__DlRC$$Wd__"